export async function getBrowserSearchCompatibleEnv(): Promise<
  Record<string, string>
> {
  const canvas = document.createElement('canvas');
  const webglContext =
    canvas.getContext('webgl') || canvas.getContext('webgl2');
  let glExtra = {};

  if (webglContext?.getExtension('WEBGL_debug_renderer_info')) {
    glExtra = {
      glInfo: webglContext.getParameter(0x1F02) || webglContext.getParameter(0x1F01) || webglContext.getParameter(0x1F00),
    }
  }

  return {
    tz_offset: String(new Date().getTimezoneOffset()),
    screen_width: String(window.screen.width),
    screen_height: String(window.screen.height),
    xj: String(navigator.webdriver),
    gl: String(Boolean(webglContext)),
    ...glExtra,
  };
}
